module.exports = __webpack_public_path__ + "media/styles/images/svg/course-white-05fe4b0a6b9bcb2375924b571c5ec087.svg";